module.exports = __webpack_public_path__ + "img/airbnb.b1d0dd39.png";